




































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import * as service from '@/services/users';
import {
  LoginAtivacaoParmDTO,
  LoginPreAtivacaoDadosDTO,
} from '@/interfaces/user';
import ListMessages from '@/components/UI/list-messages.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
  },
})
export default class UserActivationForm extends BaseComponent {
  @Prop()
  public id: string;

  private loading: boolean = false;
  private error: boolean = false;
  private dados: LoginPreAtivacaoDadosDTO = null;
  private motivo: string = null;

  public form: any = {
    valid: false,
    rules: {
      motivo: [(v) => !!v || 'Informe o motivo'],
    },
  };

  @Watch('id')
  private onChangeId() {
    this.dados = null;
    if (!this.id) {
      return;
    }
    this.loading = true;
    this.error = false;
    service.getPreActivateUserDatas(this.id).subscribe(
      (u) => {
        this.dados = u;
        this.loading = false;
        this.error = false;
      },
      (error) => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  public $refs!: {
    form: HTMLFormElement;
  };

  public validateForm(): void {
    this.$refs.form.validate();
  }

  public beforeMount(): void {}

  private resetForm() {
    if (!!this.$refs.form) {
      this.$refs.form.resetValidation();
    }
    this.dados = null;
    this.motivo = null;
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando...');
    let payload: LoginAtivacaoParmDTO = new LoginAtivacaoParmDTO();
    payload.idLogin = Number(this.id);
    payload.ativo = !this.dados.ativo;
    payload.motivo = this.motivo;

    service.activateUser(payload).subscribe(
      (res) => {
        this.loader.stop();
        this.$emit('aftersave', res);
        this.resetForm();
        if (res.ativo) {
          this.toast.show('Usuário ativado com sucesso!', 'success');
        } else {
          this.toast.show('Usuário desativado com sucesso!', 'success');
        }
      },
      (error) => {
        this.loader.stop();
        this.toast.show(error.data.message, 'error');
      },
    );
  }

  public closeForm(): void {
    const closeAction = () => {
      this.resetForm();
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }
}
